<template>
  <div>
    <plt-table ref="dg" url="MID-OPERATE-LOGISTICS/messageService/eWaybillService/queryEWayBillsByMember" :queryParams="eWaybillQueryParam" paramName="eWaybill" pageSize="15">
      <template #title>
        <span>电子运单列表</span>
        <el-button type="success" size="mini" style="margin-left: 50px" @click="openEditWaybillDialog">添加电子运单</el-button>
      </template>
      <template #table="{data, pageSize, pageNum}">
        <el-table :data="data" border size="mini" highlight-current-row @current-change="clickCustomerRow">
          <el-table-column prop="eWaybillId" label="电子运单ID" width="120" fixed />
          <el-table-column prop="action" label="操作" width="80" fixed>
            <template #default="{ row }">
              <el-dropdown>
                <el-button type="primary" size="mini">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item style="color: #ed3f14;" @click.native="downloadPdf(row)">下载交接单</el-dropdown-item>
                  <el-dropdown-item style="color: #ed3f14;" @click.native="checkReceipts(row)">交接记录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

          </el-table-column>
          <el-table-column prop="businessNo" label="业务编号" width="100" />
          <el-table-column prop="productName" label="货品名称" width="100" />
          <el-table-column prop="productQuantity" label="货品数量" width="100" />
          <el-table-column prop="remark" label="备注" width="100" show-overflow-tooltip="true" />
          <plt-table-dict-col prop="fromMemberId" label="发货客户" width="150" namespace="bizObjects" id="member" />
          <el-table-column prop="fromName" label="发货联系人" width="100" />
          <el-table-column prop="fromPhoneNumber" label="发货电话" width="100" />
          <plt-table-dict-col prop="fromAreaId" label="区域" width="120" namespace="region" id="fullArea" />
          <el-table-column prop="fromDetailAddress" label="详细地址" width="100" />
          <plt-table-dict-col prop="toMemberId" label="收货客户" width="150" namespace="bizObjects" id="member" />
          <el-table-column prop="toName" label="收货人" width="100" />
          <el-table-column prop="toPhoneNumber" label="收货电话" width="100" />
          <plt-table-dict-col prop="toAreaId" label="区域" width="120" namespace="region" id="fullArea" />
          <el-table-column prop="toDetailAddress" label="详细地址" width="100" />
          <plt-table-dict-col prop="logisticMemberId" label="承运公司" width="150" namespace="bizObjects" id="member" />
          <el-table-column prop="driverName" label="司机名称" width="100" />
          <el-table-column prop="driverPhoneNumber" label="司机手机" width="100" />
          <el-table-column prop="plateNumber" label="车牌号" width="100" />

        </el-table>
      </template>
    </plt-table>

    <edit-waybill-dialog ref="dl-wb" @on-edit-success="$refs['dg'].queryData()" />

  </div>
</template>
<script>
import editWaybillDialog from "./edit-waybill-dialog";
import { saveFile } from "@/libs/utils/localUtil.js";

export default {
  components: { editWaybillDialog },
  data() {
    return {
      eWaybillQueryParam: {
        masterMemberId: "",
      },
    };
  },
  created() {
    this.eWaybillQueryParam.masterMemberId = sessionStorage.getItem("memberId");
  },
  methods: {
    openEditWaybillDialog() {
      this.$refs["dl-wb"].openDialog();
    },
    checkReceipts(row) {
      this.$router.push({
        path: "/user-center/signing/e-waybill-receipts",
        query: { eWaybillId: row.eWaybillId },
      });
    },
    async downloadQRcode(row) {
      let url =
        "MID-TECH-OUTERGATEWAY/messageService/wechatService/getPageQRCode";

      let body = {
        appCode: "mp_e_sign",
        pagePath: "pages/upload-receipt/upload-receipt",
        scene: "eWaybillId=" + row.eWaybillId,
      };

      let result = await this.request(
        "/downLoadImage",
        { url, body },
        { responseType: "arraybuffer" }
      );
      let fileName = row.eWaybillId + ".png";
      this.pltUtil.saveFile(fileName, result);
    },
    downloadPdf(row) {
      let params = {
        exportId: "e_waybill_note",
        body: {
          eWaybillId: row.eWaybillId,
        },
      };

      this.request("/exportPDF", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        responseType: "arraybuffer",
      }).then((rs) => {
        this.pltUtil.saveFile("签收单.pdf", rs);
      });
    },
  },
};
</script>